module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.popperOptions) ? _c('div', [_c('pop-over', {
    attrs: {
      "options": _vm.popperOptionsComputed
    }
  }, [_c('span', {
    class: _vm.computedClasses
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")])])], 1) : _c('span', {
    class: _vm.computedClasses
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb3d6942","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/SensualBadge.vue
// module id = 2009
// module chunks = 0